<template>
  <a-row :gutter="24" class="new-row">
    <a-col :md="collapsed? 0: 5" :sm="24" class="new-col">
      <a-card :bordered="false" class="new-tree-card">
        <!-- 按钮操作区域 -->
        <div style="background: #fff;padding-left:16px;height: 100%; margin-top: 5px">
          <a-alert type="info" :showIcon="true">
            <div slot="message">
              {{ $t('当前选择：') }}<span v-if="this.currSelected.title">{{ getCurrSelectedTitle() }}</span>
              <a v-if="this.currSelected.title" style="margin-left: 10px" @click="unselect">{{ $t('取消选择') }}</a>
            </div>
          </a-alert>
          <div style="display: flex;margin-top: 10px;">
            <a-input-search v-model="searchAreaValue" style="width:100%;margin-right: 5px;" allowClear :placeholder="$t('请输入区域名称')"/>
            <a-button type="default" @click="collapseAll">{{ $t('折叠') }}</a-button>
          </div>
          <!-- 树-->
          <a-col :md="24" :sm="24" class="new-tree-col">
            <template>
              <a-spin tip="Loading..." :spinning="areaLoading">
                <!--
                <span style="user-select: none">
                  <a-tree
                    class="my-area-select-tree"
                    @select="onSelect"     
                    :selectedKeys="selectedKeys"
                    :treeData="areaTree"
                    :checkStrictly="checkStrictly"
                    :expandedKeys="iExpandedKeys"
                    :autoExpandParent="autoExpandParent"
                    @expand="onExpand">
                    <template slot="title" slot-scope="{title}">
                      <span v-if="title.indexOf(searchAreaValue) > -1">
                        {{title.substr(0, title.indexOf(searchAreaValue))}}
                      <span style="color: #32CD32">{{searchAreaValue}}</span>
                        {{title.substr(title.indexOf(searchAreaValue) + searchAreaValue.length)}}
                      </span>
                      <span v-else>{{title}}</span>
                    </template>
                  </a-tree>
                </span>
                -->
                <el-tree
                  class="filter-tree"
                  :data="areaTree"
                  :props="defaultProps"
                  :expand-on-click-node="false"
                  :filter-node-method="filterNode"
                  :check-on-click-node="true"
                  :check-strictly="checkStrictly"
                  :highlight-current="true"
                  node-key="id"
                  :current-node-key="currentNodeKey"
                  :default-expanded-keys="iExpandedKeys"
                  @node-click="nodeClick"
                  ref="areaTree">
                </el-tree>
              </a-spin>
            </template>
          </a-col>
        </div>
      </a-card>
    </a-col>
    <a-col :md="collapsed? 24: 19" :sm="24" style="position: relative;padding-left: 30px" class="new-col">
      <a-icon :type="collapsed ? 'caret-right':'caret-left'" 
        @click="collapsed = !collapsed"
        class="area-collapsed"></a-icon>
      <a-card :bordered="false" class="new-table-card">
        <!-- 查询区域 -->
        <div class="table-page-search-wrapper">
          <a-form layout="inline" @keyup.enter.native="searchQuery">
            <a-row :gutter="24">
                <a-col :xl="8" :lg="7" :md="8" :sm="24">
                <a-form-item :label="$t('日期')">
                  <a-range-picker
                    v-model="date"
                    format="YYYY-MM-DD"
                    :placeholder="[$t('查询起始日期'), $t('查询结束日期')]"
                    @change="onDateRangeChange"
                    @ok="onOk"
                  />
                </a-form-item>
              </a-col>
              <a-col :xl="6" :lg="7" :md="8" :sm="24">
                <a-form-item :label="$t('统计层级')">
                  <a-select v-model="queryParam.targetLevel" :placeholder="$t('请选择统计层级')" allowClear>
                    <a-select-option :value="1">{{ $t('一级区域') }}</a-select-option>
                    <a-select-option :value="2">{{ $t('二级区域') }}</a-select-option>
                    <a-select-option :value="3">{{ $t('三级区域') }}</a-select-option>
                    <a-select-option :value="99">{{ $t('其他') }}</a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
              <!-- </template> -->
              <a-col :xl="6" :lg="7" :md="8" :sm="24">
                <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
                  <a-button type="primary" @click="searchQuery" icon="search">{{ $t('查询') }}</a-button>
                  <a-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px">{{ $t('重置') }}</a-button>
                  <!-- <a @click="handleToggleSearch" style="margin-left: 8px">
                    {{ toggleSearchStatus ? '收起' : '展开' }}
                    <a-icon :type="toggleSearchStatus ? 'up' : 'down'"/>
                  </a> -->
                </span>
              </a-col>
            </a-row>
          </a-form>
        </div>
        <!-- 查询区域-END -->

        <!-- 操作按钮区域 -->
        <div class="table-operator">
          <a-button type="primary" icon="download" @click="handleExportXls($t('区域用量报表'))">{{ $t('导出') }}</a-button>
        </div>
        <!-- 汇总显示 -->
        <a-descriptions :column="4">
          <a-descriptions-item :label="$t('使用总量')">
            <span v-if="loading">
              <a-spin size="small" />
            </span>
            <span v-else>
              {{sumUse+' m³'}}
            </span>
          </a-descriptions-item>
        </a-descriptions>
        <!-- table区域-begin -->
        <div class="table-fixed">
          <div class="flex flex-center">
            <div class="echart flex-item" style="height: 400px">
            <Echart ref="option" :options="option" style="height: 100%"></Echart>
            </div>
            <div class="echart flex-item" style="height: 400px">
            <Echart ref="option2" :options="option2" style="height: 100%"></Echart>
            </div>
          </div>
          
          <a-table
            ref="table"
            size="middle"
            :scroll="{x:true}"
            bordered
            rowKey="userAreaId"
            :columns="columns"
            :dataSource="dataSource"
            :pagination="false"
            :loading="loading"
            class="j-table-force-nowrap"
            @change="handleTableChange">

            <span slot="action" slot-scope="text, record">
              <a @click="handleDetail(record)">{{ $t('详情') }}</a>
            </span>
          </a-table>
        </div>
      </a-card>
    </a-col>
  </a-row>
</template>

<script>

  import '@/assets/less/TableExpand.less'
  import { mixinDevice } from '@/utils/mixin'
  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  import {AreaChoosetMixin} from '@/mixins/AreaChooseMixin'
  import { getAction,putAction } from '@/api/manage'
  import echarts from 'echarts/lib/echarts';
  import moment from 'moment'
  // import Vue from 'vue'

  export default {
    name: 'MeterUserWaterReportAreaList',
    mixins:[JeecgListMixin, mixinDevice,AreaChoosetMixin],
    components: {
    },
    data () {
      return {
        description: '区域用量报表',
        collapsed: false,
        date:[],
        //列设置
        // settingColumns:[],
        url: {
          // list: "/baodi-charge/meter/meterUserWaterReportDay/areaUseList",
          list: "/jeecg-charge/meter/meterUserWaterReportDay/areaUsageReport",
          exportXlsUrl: "jeecg-charge/meter/meterUserWaterReportDay/exportXlsForAreaUseList",
        },
        option: {},
        option2: {},
          /* 分页参数 */
        ipagination:{
          current: 1,
          pageSize: 10,
          pageSizeOptions: ['10'],
          showTotal: (total, range) => {
            return range[0] + "-" + range[1] + " " + this.$t('共{total}条', { total: total })
          },
          showQuickJumper: true,
          showSizeChanger: true,
          total: 0
        },
        disableMixinCreated: false,
        sumUse: 0,
        queryParam: {
          targetLevel: 2,
        }
      }
    },
    created() {
      this.$store.commit('SET_LAYOUT_TREE',true)
      this.loadData();
      //初始化字典配置 在自己页面定义
      this.initDictConfig();
      this.loadTree();
    },
    computed: {
      importExcelUrl: function(){
        return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`;
      },
      // i18n：列定义使用 computed 以响应语言切换
      columns() {
        return [
          {
            title: '#',
            dataIndex: '',
            key:'rowIndex',
            width:60,
            align:"center",
            customRender: (t,r,index) => {
              return parseInt(index)+1;
            },
          },
          // {
          //   title:'区域ID',
          //   align:"center",
          //   dataIndex: 'userAreaId'
          // },
          {
            title: this.$t('区域名称'),
            align:"center",
            dataIndex: 'areaName'
          },{
            title: this.$t('区域用量(m³)'),
            align:"center",
            dataIndex: 'areaUse'
          },
        ]
      },
    },
    methods: {
      loadData(arg) {
        if(!this.url.list){
          this.$message.error(this.$t('请设置url.list属性!'))
          return
        }
        //加载数据 若传入参数1则加载第一页的内容
        if (arg === 1) {
          this.ipagination.current = 1;
        }
        if(!this.queryParam.beginDate||!this.queryParam.beginDate) {
          let date = moment().subtract(1, 'day');
          this.date[0] = date;
          this.date[1] = date;
          this.queryParam.beginDate = moment(this.date[0]).format('YYYY-MM-DD');
          this.queryParam.endDate = moment(this.date[1]).format('YYYY-MM-DD');
        }else{
          this.queryParam.beginDate = moment(this.date[0]).format('YYYY-MM-DD');
          this.queryParam.endDate = moment(this.date[1]).format('YYYY-MM-DD');
        }
        var params = this.getQueryParams();//查询条件
        params.largeScreenAreaId = this.currSelected?this.currSelected.id:'';
        this.loading = true;
        getAction(this.url.list, params).then((res) => {
          console.log(res.result.records);
          if (res.success) {
            let data = res.result.result;
            const areaInfoKeys = Object.keys(data.areaInfoMap);
            const areaInfoValues = Object.values(data.areaInfoMap);
            this.dataSource = areaInfoKeys.map((key,index) => ({
              key: key,
              areaName: areaInfoValues[index],
              areaUse: data.areaWaterUseMap[this.queryParam.beginDate][index]
            }))
            let sumUse = 0;
            data.areaWaterUseMap[this.queryParam.beginDate].forEach(number => {
              sumUse += number;
            })
            this.sumUse = sumUse.toFixed(2);
            // this.dataSource = res.result.records;
            // this.ipagination.total = res.result.total;
            let that = this;
            this.$nextTick(()=> {
              setTimeout(() => {
                that.$refs.option.showLoading('default',{
                    maskColor: 'rgba(0,0,0,0.3)',
                    color: '#6ED9F2',
                    text: ''
                });
                that.$refs.option2.showLoading('default',{
                      maskColor: 'rgba(0,0,0,0.3)',
                      color: '#6ED9F2',
                      text: ''
                  });
                that.dealData(that.dataSource);
              }, 500);
              
            })
            
          }
          if(res.code===510){
            this.$message.warning(res.message)
          }
          this.loading = false;
        })
      },
      dealData(list) {
        let categoryData = []
        let seriesData = []
        for(let i=0;i<list.length;i++) {
          let index = list[i].areaName.lastIndexOf('-');
          if(index>-1) {
            categoryData.push(list[i].areaName.substring(index+1))
          }else {
            categoryData.push(list[i].areaName)
          }
          seriesData.push(list[i].areaUse)
        }
        this.setOption(categoryData,seriesData)
        this.setOption2(categoryData,seriesData)
      },
      setOption(categoryData,seriesData) {
        this.option = {
          backgroundColor: '#e6f7ff',
          title: {
              text: 'm³',
              textStyle: {
                  fontWeight: 'normal',
                  fontSize: 16,
                  color: '#000000'
              },
              top: '0%',
              left: '3%'
          },
          tooltip: {
              trigger: 'axis',
              axisPointer: {
                  type: 'shadow'
              },
              formatter: "{b}: {c} m³"
          },
          dataZoom: [
            // {
            //   type: 'inside',
            //   start: 0,
            //   end: categoryData.length/2,
            // },
            {
              type: 'slider',
            },
          ],
          grid: {
            left: '3%',
            right: '4%',
            bottom: '13%',
            containLabel: true
          },
          xAxis: [{
              type: 'category',
              data: categoryData,
              axisLine: {
                  lineStyle: {
                      color: 'rgba(255,255,255,0.12)'
                  }
              },
              axisLabel: {
                  margin: 10,
                  //color: '#e2e9ff',
                  textStyle: {
                      fontSize: 14
                  },
              },
              splitLine: {
                show: false,
                lineStyle: {
                  color: '#233e64'
                }
              },
          }],
          yAxis: [{
              splitNumber: 3,
              axisLabel: {
                  formatter: '{value}',
                  //color: '#e2e9ff',
              },
              axisLine: {
                  show: false
              },
          splitLine: {
            show: true,
            lineStyle: {
              color: '#D4F2E7'
            }
          },
          }],
          series: [{
              type: 'bar',
              data: seriesData,
              barMaxWidth: 14,
              itemStyle: {
                  normal: {
                      color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                          offset: 0,
                          color: 'rgba(0,210,255,1)' // 0% 处的颜色
                      }, {
                          offset: 1,
                          color: 'rgba(58,123,213,1)' // 100% 处的颜色
                      }], false),
                      barBorderRadius: [30, 30, 30, 30],
                      shadowColor: 'rgba(0,160,221,1)',
                      //shadowBlur: 4,
                  }
              }
          }]
        }
        this.$refs.option.hideLoading()
      },
      setOption2(categoryData,seriesData) {
        var data = [];
        var color = ['#FECA20','#50E3C2', '#32C5FF','#0091FF','#0394FF','#4634FA','#0C2D82','#B620E0','#F7B500','#FA6400','#E02020'];
        for (var i = 0; i < categoryData.length; i++) {
            data.push({
                value: seriesData[i],
                name: categoryData[i],
                /*
                itemStyle: {
                    normal: {
                        //borderWidth: 5,
                        //shadowBlur: 20,
                        borderColor: color[i],
                        shadowColor: color[i]
                    }
                }
                */
            });
        }
        var seriesOption = [{
            name: '',
            type: 'pie',
            clockWise: false,
            radius: ['35%','45%'],
            hoverAnimation: false,
            itemStyle: {
                normal: {
                    label: {
                        show: true,
                        position: 'outside',
                        //color: '#ddd',
                        formatter: function (params) {
                          return params.name + ': '+ params.value + 'm³ (' + params.percent + '%)';
                      }
                    },
                    labelLine: {
                        length: 30,
                        length2: 45,
                        show: true,
                        color: '#00ffff'
                    }
                }
            },
            data: data
        }];
        this.option2 = {
            backgroundColor: '#e6f7ff',
            color: color,
            title: {
                text: this.$t('区域用量统计'),
                top: '48%',
                textAlign: "center",
                left: "49%",
                textStyle: {
                    color: '#000000',
                    fontSize: 14,
                    fontWeight: '500'
                }
            },
            tooltip: {
                show: true,
                formatter: "{b}: {c} m³"
            },
            legend: {
                icon: "circle",
                orient: 'horizontal',
                type: 'scroll',
                // x: 'left',
                data: categoryData,
                //right: 250,
                bottom: 20,
                //align: 'right',
                textStyle: {
                    //color: "#fff"
                },
                itemGap: 20
            },
            toolbox: {
                show: false
            },
            series: seriesOption
        }
        this.$refs.option2.hideLoading()
      },
      onOk(value) {
        console.log('onOk:', value);
      },
      searchReset() {
        this.queryParam = {
          targetLevel: 2,
        }
        this.loadData(1);
      },
    }
  }
</script>
<style scoped>
  .echart{
    height: 400px;
  }
  .my-area-select-tree /deep/ li .ant-tree-node-content-wrapper{
    overflow: hidden;
    text-overflow: ellipsis;
    width: 100%;
    white-space: nowrap;
  }
</style>